import { useEffect, useState } from "react";
import { todayIso } from "@/lib/format";

/** Today's date (YYYY-MM-DD, the device's day), kept current. A page left
 *  open past midnight would otherwise go on calling yesterday "today".
 *  Checked every minute, and when the tab comes back into view: a laptop
 *  that slept through midnight runs no timers. */
export function useTodayIso(): string {
  const [today, setToday] = useState(todayIso);
  useEffect(() => {
    const check = () => setToday(todayIso());
    const id = window.setInterval(check, 60_000);
    document.addEventListener("visibilitychange", check);
    return () => {
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", check);
    };
  }, []);
  return today;
}
